export const DEFAULT_MIN_COMMISSION_WITHDRAW = 100

export function resolveMinCommissionWithdraw(
  value?: number | null,
  fallback = DEFAULT_MIN_COMMISSION_WITHDRAW,
): number {
  if (typeof value === 'number' && Number.isFinite(value) && value >= 0) {
    return value
  }
  return fallback
}

export function canAffiliateCommissionWithdraw(
  remaining: number,
  minWithdraw = DEFAULT_MIN_COMMISSION_WITHDRAW,
): boolean {
  return Number(remaining) >= resolveMinCommissionWithdraw(minWithdraw)
}

export function affiliateWithdrawShortfall(
  remaining: number,
  minWithdraw = DEFAULT_MIN_COMMISSION_WITHDRAW,
): number {
  const min = resolveMinCommissionWithdraw(minWithdraw)
  return Math.max(0, min - Number(remaining || 0))
}

export function affiliateWithdrawProgress(
  remaining: number,
  minWithdraw = DEFAULT_MIN_COMMISSION_WITHDRAW,
): number {
  const min = resolveMinCommissionWithdraw(minWithdraw)
  if (min <= 0) return 100
  return Math.min(100, (Number(remaining || 0) / min) * 100)
}
